export * from './src/bookings-reader-v2-extended-booking-extended-bookings.meta.js';
